import { useEffect, useMemo, useState } from 'react';
import signalService from '../services/signalService';
import { useAuth } from '../context/AuthContext';
import { usePortalPosting } from '../context/PortalPostingContext';

/**
 * Which events you've already opened a Portal from — `portalFor(eventId)` → { portalId } | null.
 * Event cards use it to read PORTAL OPEN and tap through to that Portal instead of offering a
 * second. Your live Portals come from /signals/mine/sources; one still going up counts from the
 * moment you press SEND.
 */
export default function useMyPortalSources() {
  const { isAuthenticated } = useAuth();
  const { posting } = usePortalPosting();
  const [mine, setMine] = useState([]);

  useEffect(() => {
    if (!isAuthenticated) { setMine([]); return undefined; }
    let cancelled = false;
    signalService.mySources()
      .then((r) => { if (!cancelled && r?.success) setMine(r.data || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isAuthenticated]);

  return useMemo(() => {
    const map = new Map(mine.map((m) => [m.sourceEventId, m]));
    if (posting?.sourceEventId && posting.eventId && posting.status !== 'failed' && !map.has(posting.sourceEventId)) {
      map.set(posting.sourceEventId, { sourceEventId: posting.sourceEventId, portalId: posting.eventId });
    }
    return (eventId) => map.get(eventId) || null;
  }, [mine, posting]);
}
